import { MobileRequest } from '@sai/protocol';

class SubscribeRequest extends MobileRequest {
    private pages: { [key: string] : any };

    constructor(pages: {[key: string]: any}) {
        super('subscribe', 'subscribe', 'POST', null);
        this.pages = pages;
    }

    getSerializable(): { [prop: string]: any } {
        return {
            request1: this.pages
        }
    }
}

export default SubscribeRequest;